import Vue from 'vue';

export default {

    SET_SEARCHTERM (state, searchTerm) {
      state.searchTerm = searchTerm
    },
    SET_CURRENT_SITE (state, selectedSite) {
      state.selectedSite = selectedSite
    },
    UNSET_CURRENT_SITE (state, selectedSite) {
      state.selectedSite = ''
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js